import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  addEmail,
  deleteEmail,
  getEmailList,
  updateEmail,
} from "../../api/EmailListApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import { appTitle } from "../common/GeneralConfigurations";
import EmailListPageForm from "./EmailListPageForm";

function ManageEmailListPage() {
  const [data, setData] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [visible, setVisible] = useState(false);
  const [emailHandler, setEmailHandler] = useState([]);
  const [event, setEvent] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    document.title = `${appTitle} - Emails`;
  }, []);

  useEffect(() => {
    GetEmailData();
  }, []);

  useEffect(() => {
    let filteredData = data.filter((a) => a.name.startsWith("_"));
    filteredData = filteredData.filter((value, index, self) => {
      return self.findIndex((v) => v.name === value.name) === index;
    });

    setDropdownOptions(filteredData);
  }, [data]);

  const GetEmailData = () => {
    getEmailList().then((res) => {
      setData(res.data);
      setLoading(false);
    });
  };
  const handleForm = (values) => {
    setSubmitLoading(true);
    if (event === "add") {
      addEmail(values).then((res) => {
        console.log(res);
        if (res.status === 200) {
          GetEmailData();
          setVisible(false);
          AdnMessageSuccess();
        } else {
          const errors = res.data.errors;

          errors.forEach((error) => {
            const errorMessage = error.message;
            AdnMessageError(errorMessage);
          });
        }
        setSubmitLoading(false);
      });
    } else if (event === "edit") {
      values.id = emailHandler.id;
      updateEmail(values).then((res) => {
        if (res.status === 200) {
          GetEmailData();
          setVisible(false);
          AdnMessageSuccess();
        } else {
          const errors = res.data.errors;

          errors.forEach((error) => {
            const errorMessage = error.message;
            AdnMessageError(errorMessage);
          });
        }
        setSubmitLoading(false);
      });
    }
  };

  const deleteRecord = (id) => {
    deleteEmail(id).then((res) => {
      if (res.status === 200) {
        GetEmailData();
        setVisible(false);
        AdnMessageSuccess();
      } else {
        AdnMessageError();
      }
    });
  };

  return (
    <>
      <EmailListPageForm
        data={data}
        visible={visible}
        emailHandler={emailHandler}
        event={event}
        setVisible={setVisible}
        handleForm={handleForm}
        setEmailHandler={setEmailHandler}
        setEvent={setEvent}
        deleteRecord={deleteRecord}
        loading={loading}
        submitLoading={submitLoading}
        dropdownOptions={dropdownOptions}
      />
    </>
  );
}

export default ManageEmailListPage;
